import { SearchType } from 'contexts/searchParams';

export const areaCodeBySearchType = new Map([
  [SearchType.INTERNATIONAL, 'ift'],
  [SearchType.DOMESTIC, 'lft'],
]);
